import {
    IMPORTED_LEAGUE_GET_SUMMARY_REQUEST,
    IMPORTED_LEAGUE_GET_SUMMARY_SUCCESS,
    IMPORTED_LEAGUE_GET_SUMMARY_FAILURE,
    IMPORTED_LEAGUE_GET_PLAYERS_REQUEST,
    IMPORTED_LEAGUE_GET_PLAYERS_SUCCESS,
    IMPORTED_LEAGUE_GET_PLAYERS_FAILURE,
    IMPORTED_LEAGUE_GET_DRAWS_REQUEST,
    IMPORTED_LEAGUE_GET_DRAWS_SUCCESS,
    IMPORTED_LEAGUE_GET_DRAWS_FAILURE,
    IMPORTED_LEAGUE_GET_FILTERS_REQUEST,
    IMPORTED_LEAGUE_GET_FILTERS_SUCCESS,
    IMPORTED_LEAGUE_GET_FILTERS_FAILURE,
    IMPORTED_LEAGUE_GET_RESULTS_REQUEST,
    IMPORTED_LEAGUE_GET_RESULTS_SUCCESS,
    IMPORTED_LEAGUE_GET_RESULTS_FAILURE,
} from '../actions/actionTypes/imported-league-action-types';

const initialState = {
    summary: {
        data: null,
        loading: false,
        error: null,
    },
    players: {
        data: [],
        totalCount: 0,
        loading: false,
        error: null,
    },
    draws: {
        data: [],
        loading: false,
        error: null,
    },
    filters: {
        data: null,
        loading: false,
        error: null,
    },
    // Flat slice, not the tournament's resultsByDrawId + resultsSearch pair (decisions.md D10) -
    // league fetches once in full and narrows client-side, so there is nothing to cache per-draw
    // or per-search-term.
    results: {
        data: { draws: [], totalCount: 0 },
        loading: false,
        error: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case IMPORTED_LEAGUE_GET_SUMMARY_REQUEST: {
            return {
                ...state,
                summary: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_SUMMARY_SUCCESS: {
            return {
                ...state,
                summary: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_SUMMARY_FAILURE: {
            return {
                ...state,
                summary: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_PLAYERS_REQUEST: {
            return {
                ...state,
                players: {
                    data: [],
                    totalCount: 0,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_PLAYERS_SUCCESS: {
            return {
                ...state,
                players: {
                    data: action.payload.players,
                    totalCount: action.payload.totalCount,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_PLAYERS_FAILURE: {
            return {
                ...state,
                players: {
                    data: [],
                    totalCount: 0,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_DRAWS_REQUEST: {
            return {
                ...state,
                draws: {
                    data: [],
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_DRAWS_SUCCESS: {
            return {
                ...state,
                draws: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_DRAWS_FAILURE: {
            return {
                ...state,
                draws: {
                    data: [],
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_FILTERS_REQUEST: {
            return {
                ...state,
                filters: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_FILTERS_SUCCESS: {
            return {
                ...state,
                filters: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_FILTERS_FAILURE: {
            return {
                ...state,
                filters: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_RESULTS_REQUEST: {
            return {
                ...state,
                results: {
                    data: { draws: [], totalCount: 0 },
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_RESULTS_SUCCESS: {
            return {
                ...state,
                results: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_LEAGUE_GET_RESULTS_FAILURE: {
            return {
                ...state,
                results: {
                    data: { draws: [], totalCount: 0 },
                    loading: false,
                    error: action.payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};
